export const BundleDropdown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_2461_12106)">
        <path
          d="M5 5.5V7C5 7.26522 5.10536 7.51957 5.29289 7.70711C5.48043 7.89464 5.73478 8 6 8H11.5C11.7652 8 12.0196 8.10536 12.2071 8.29289C12.3946 8.48043 12.5 8.73478 12.5 9V10.5"
          stroke="#706A85"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 10.5V5.5"
          stroke="#706A85"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 10.5C5.82843 10.5 6.5 11.1716 6.5 12C6.5 12.8284 5.82843 13.5 5 13.5C4.17157 13.5 3.5 12.8284 3.5 12C3.5 11.1716 4.17157 10.5 5 10.5Z"
          stroke="#706A85"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 10.5C13.3284 10.5 14 11.1716 14 12C14 12.8284 13.3284 13.5 12.5 13.5C11.6716 13.5 11 12.8284 11 12C11 11.1716 11.6716 10.5 12.5 10.5Z"
          stroke="#706A85"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 2.5C5.82843 2.5 6.5 3.17157 6.5 4C6.5 4.82843 5.82843 5.5 5 5.5C4.17157 5.5 3.5 4.82843 3.5 4C3.5 3.17157 4.17157 2.5 5 2.5Z"
          stroke="#706A85"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2461_12106">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(1 0 0 -1 0 16)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
